export enum TrafficType {
	INTERNAL = 'internal',
	EXTERNAL = 'external',
	DEVELOPER = 'developer',
}
